import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './timing-tips.css';

class TimingTips extends Component {
    componentDidMount () {
        this.timingTipsCompFlag = setTimeout(() => {
            this.props.onHideTips();
        }, this.props.duration * 1000);
    }

    componentWillUnmount () {
        clearTimeout(this.timingTipsCompFlag);
    }

    timingTipsCompFlag;

    render () {
        return (
            <div className={styles.timingTipsWrap}>
                {
                    this.props.tips &&
                    <div className={styles.timingTipsContainer}>
                        {this.props.tips}
                    </div>
                }
            </div>
        );
    }
}

TimingTips.propTypes = {
    duration: PropTypes.number,
    onHideTips: PropTypes.func,
    tips: PropTypes.string
};

export default TimingTips;
